import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { Col, Container, Row } from "reactstrap";
import footerImage from "../../../../assets/preview/facebook-buttons-footer.png";
import fakeTextHeader from "../../../../assets/preview/preview-fake-text-header.png";
import fakeText from "../../../../assets/preview/preview-fake-text.png";
import { useFacebookCore } from "../../../../cores/facebook";
import { useSocialPostCore } from "../../../../cores/socialPost";
import { SocialProviderId } from "../../../../cores/socialPost/config";
import { PostError } from "../../../../cores/socialPost/interfaces/postError";
import { ErrorList } from "./ErrorList";
import { MediaPreview } from "./MediaPreview";

export const FacebookPostPreview = () => {
  const { settings } = useFacebookCore();
  const { text, mentions, postErrors } = useSocialPostCore();
  const { name, avatarUrl } = settings || {};

  const providerErrors: PostError[] = useMemo(
    () =>
    postErrors.filter(
        ({ socialProviderId }) =>
          socialProviderId === SocialProviderId.Facebook
      ),
    [postErrors]
  );

  const formattedText = useMemo(() => {
    const orderMentions = 
      mentions.sort((a, b) => (a.offset > b.offset) ? -1 : 1);

    let txt = text;
    orderMentions.forEach((mention) => {
      const submention = mention.mentions.find(
        (submention) => submention.socialProviderId === SocialProviderId.Facebook)
      const name = submention
        ? `<span style="color:#38b6ff;">${submention.username}</span>`
        : mention.mentions[0].username
      const offset = mention.offset + mention.mentions[0].username.length + 1
      txt = txt.slice(0, mention.offset) + name + txt.slice(offset);
    });
    
    return txt;
  }, [text, mentions]);

  return providerErrors.length > 0 ? (
    <ErrorList errors={providerErrors} />
  ) : (
    <div className="facebookPreview-container neu-out p-2">
      <Container fluid>
        <Row className="facebookPreview-header">
          <Col xs="6" className="d-flex align-items-center p-0">
            <div>
              <img
                className="facebookPreview-header-avatar"
                src={avatarUrl}
                alt="avatar"
              />
            </div>
            <div>
              <div>{name}</div>
              <div>
                <img src={fakeTextHeader} alt="avatar" />
              </div>
            </div>
          </Col>
          <Col
            xs="6"
            className="align-content-center col-6 d-flex justify-content-end"
          >
            <FontAwesomeIcon icon={["fas", "ellipsis-h"]} />
          </Col>
        </Row>
        <Row className="facebookPreview-description">
          <Col xs="12" className=" p-0">
            {formattedText ? (
              <div className="px-2 line-break-anywhere pre-wrap">
                <div dangerouslySetInnerHTML={{
                  __html: formattedText
                }}></div>
              </div>
            ) : (
              <img
                src={fakeText}
                alt="fake-text"
                className="facebookPreview-footer"
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs="12" className="p-0">
            <MediaPreview className="facebookPreview-image" />
          </Col>
        </Row>
        <Row>
          <img
            className="facebookPreview-footer"
            src={footerImage}
            alt="footer"
          />
        </Row>
      </Container>
    </div>
  );
};
